<template>
  <div v-if="store.NOTARIA" class="mt-raiz">
    <MinotariaCabecera />
    <v-main id="main" class="mt-main" :class="{ 'mt-main--pagina': !esInicio }">
      <MinotariaInicio v-if="esInicio" />
      <MinotariaBlog v-else-if="nombreRuta === 'Blog'" />
      <MinotariaArticulo v-else-if="nombreRuta === 'blog-id'" :key="String(route.params.id)" />
      <slot v-else>
        <NuxtPage/>
      </slot>
    </v-main>
    <MinotariaPie />
  </div>

  <ClientOnly>
    <div id="client-components-wrapper">
      <ElementsButtonUp />
      <Cookies/>
      <!-- Chatbot IA con instrucciones de portal (las pone la API), ref: https://trello.com/c/bLCIu6IX -->
      <ChatAIChatbot />
    </div>
  </ClientOnly>
</template>
<script setup>
import { computed, watch, onMounted, onBeforeUnmount } from 'vue'
import { useStore } from '../store/index.ts'
import { usePlantilla } from '../composables/usePlantilla'
import { registrarTokenDestino } from '../composables/useSolicitudWeb'
import { tokenRecaptchaGrupo } from '../composables/useMinotaria'
import MinotariaInicio from '../components/minotaria/MinotariaInicio.vue'
import MinotariaCabecera from '../components/minotaria/MinotariaCabecera.vue'
import MinotariaPie from '../components/minotaria/MinotariaPie.vue'
import MinotariaBlog from '../components/minotaria/MinotariaBlog.vue'
import MinotariaArticulo from '../components/minotaria/MinotariaArticulo.vue'
import '../assets/minotaria.scss'

const store = useStore()
// Ruta del router, no useRoute(): en un layout useRoute() espera a que cargue la página, y en la portada
// no se pinta ninguna página (se pinta MinotariaInicio), así que no avanzaría al navegar
const route = useRouter().currentRoute
const { plantilla } = usePlantilla()

const nombreRuta = computed(() => String(route.value.name || '').replace(/^lang-/, ''))
const esInicio = computed(() => nombreRuta.value === 'index')

// Solo existen las páginas de la plantilla; el resto de la web de notaría no se sirve aquí.
// El blog y la portada los pinta el layout con componentes propios, no la página de notaría
watch(nombreRuta, (nombre) => {
  const rutas = plantilla.value.rutas?.(store.NOTARIA)
  if (rutas && nombre && !rutas.includes(nombre)) showError({ statusCode: 404, statusMessage: 'Page Not Found' })
}, { immediate: true })

// Pestaña del navegador: el nombre de la web ("minotaria") y, si la página tiene título propio, delante.
// Sin título propio Nuxt pone el genérico de nuxt.config ("Notaría"), que aquí no vale.
const nombreWeb = computed(() => store.NOTARIA?.Nombre || 'minotaria')
useHead({
  titleTemplate: (titulo) =>
    titulo && titulo !== 'Notaría' && titulo !== nombreWeb.value ? `${titulo} | ${nombreWeb.value}` : nombreWeb.value,
})

// El envío con notaría elegida se firma con la clave de reCAPTCHA del grupo de esa notaría
onMounted(() => registrarTokenDestino(tokenRecaptchaGrupo))
onBeforeUnmount(() => registrarTokenDestino(null))
</script>
